import { TrackByFunction } from '@angular/core';
import { IMessage } from '../message';

export function trackMessageByKey<T extends IMessage>(): TrackByFunction<T> {
  return (_, item) => item.key;
}
